import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { MyMessage,MyStorage } from '@/common.js'
Vue.use(Router)
var router = new Router({
  // mode: 'history',
  // base: 'content',
  routes: [
    { path: '/login', name: 'login', meta: {noCheckLogined: true}, component: () => import('./views/Login.vue') },
    {
      path: '/', name: 'home', component: Home, children: [
          { path: '/test',  component: () => import('./views/Test.vue') },
        { path: '/article',  component: () => import('./views/article/Index.vue') },
        { path: '/article/edit/:id', name: 'article_edit', component: () => import('./views/article/Edit.vue') },
        { path: '/game',  component: () => import('./views/game/Index.vue') },
        { path: '/game/edit/:id', name: 'game_edit', component: () => import('./views/game/Edit.vue') },
        { path: '/about',  component: () => import('./views/About.vue') },
				{ path: '/ad',  component: () => import('./views/ad/Index.vue') },
				{ path: '/ad/edit/:id', name: 'ad_edit', component: () => import('./views/ad/Edit.vue') },
				{ path: '/bidding',  component: () => import('./views/bidding/Index.vue') },
				{ path: '/ad_bidding',  component: () => import('./views/bidding/Add.vue') },
        { path: '/material',  component: () => import('./views/material/Index.vue') },
        { path: '/material/edit/:id', name: 'material_edit', component: () => import('./views/material/Edit.vue') },
      ]
    },
  ]
});
router.beforeEach((to, from, next) => {
  // 判断要去的路由界面是不是要鉴权
  console.log(to.meta.noCheckLogined);
  if (to.meta.noCheckLogined) {
    // 不需要鉴权的正常跳
    next()
  } else {
    if (MyStorage.getItem('userInfo') && 
        MyStorage.getItem('expiration') &&  
        MyStorage.getItem('expiration') > new Date().getTime()) {
        next()
    } else {
        MyStorage.removeItem('userInfo');
        MyStorage.removeItem('api_token');
        MyStorage.removeItem('expiration');
        MyMessage.error('请登录！');
        next('/login')
    }
  }
});
export default router;